import { useQuery } from '@tanstack/react-query';
import { ProjectOpportunityService } from '../../services/project-opportunity';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../../interfaces/errorResponse';
import { parseAxiosError } from '../../services/axios';
import { IBaseUseQueryProps } from '../../interfaces/baseUseQueryProps';
import { IProjectPosition } from '../../interfaces/projectPosition';
import { useNotification } from '../../+state/useNotification';

export const GET_PROJECT_POSITIONS_QUERY_KEY = 'get-project-positions';

interface IProps extends IBaseUseQueryProps<IProjectPosition[]> {
  clientId: number;
  projectOpportunityId: string,
}

export const useGetProjectPositions = ({ clientId, projectOpportunityId, onError, ...props }: IProps) => {
  const { openErrorToast } = useNotification();
  return useQuery({
    queryKey: [GET_PROJECT_POSITIONS_QUERY_KEY],
    queryFn: () => ProjectOpportunityService.getProjectPositions({ clientId, projectOpportunityId }),
    refetchOnWindowFocus: false,
    onError: (err: AxiosError<IErrorResponse>) => {
      openErrorToast(parseAxiosError(err));
      onError?.(err);
    },
    ...props
  });
};